<template>
  <div class="sms-biz-student-message-send">
    <div class="body">
      <div class="body-cont"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <SmsBizMessageSendInput v-model="input.content"></SmsBizMessageSendInput>
      </div>
    </div>
    <div class="footer">
      <div class="input">
        <el-select v-model="students"
                   size="mini"
                   value-key="id"
                   multiple
                   filterable
                   popper-class="sms-biz-student-message-send-dropdown"
                   placeholder="选择发送范围，一次最多发送10个人（填写学号或姓名搜索）"
                   remote
                   reserve-keyword
                   :remote-method="queryInfo"
                   :multiple-limit="10"
                   :loading="query.fetching"
                   :disabled="committing">
          <template v-if="query.info">
            <template v-if="query.info.items && query.info.items.length">
              <el-option v-for="item in query.info.items"
                         :key="item.id"
                         :label="`${item.regNo}/${item.trueName}`"
                         :value="item"
                         :disabled="!item.mobilePhone">
                <div class="custom-option">
                  <div class="label">
                    <span>{{item.regNo}}/{{item.trueName}}</span>
                  </div>
                  <div class="extra">
                    <template v-if="item.mobilePhone">
                      <el-tag size="mini"
                              type="success">{{item.mobilePhone}}</el-tag>
                    </template>
                    <template v-else>
                      <el-tag size="mini"
                              type="info">未绑定</el-tag>
                    </template>
                  </div>
                </div>
              </el-option>
            </template>
            <el-pagination small
                           :page-size.sync="query.limit"
                           :current-page.sync="query.start"
                           :total="query.info.count || 0"
                           layout="prev, pager, next, ->, total"
                           @size-change="() => queryInfo(query.keyword)"
                           @current-change="() => queryInfo(query.keyword)">
            </el-pagination>
          </template>
        </el-select>
      </div>
      <div class="extra">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">{{committing ? '发送中...' : '开始发送'}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import SmsBizMessageSendInput from '../widget/input'
export default {
  name: 'SmsBizStudentMessageSend',
  components: {
    SmsBizMessageSendInput
  },
  data () {
    return {
      query: {
        fetching: false,
        keyword: '',
        start: 1,
        limit: 6,
        info: null
      },
      input: {
        content: ''
      },
      students: [],
      committing: false
    }
  },
  methods: {
    queryInfo (query) {
      this.query.keyword = query
      if (query) {
        this.query.fetching = true
        this.$ajax({
          url: '/workspace/manager/message/sms/student/query',
          method: 'post',
          data: this.$qs.stringify({
            query: this.query.keyword,
            start: this.query.start,
            limit: this.query.limit
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.query.info = response.data['queryInfo'] || {}
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.query.fetching = false
        })
      } else {
        this.query.info = null
      }
    },
    handleApply () {
      const input = this.input
      if (!input.content) {
        this.$message.warning('请填写短信内容')
        return
      }
      const students = this.students || []
      if (!students.length) {
        this.$message.warning('请设置发送范围')
        return
      }
      this.handleSend(students, input)
    },
    handleSend (students, input) {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/message/sms/student/bizSend',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          studentIds: students.map(t => t.id)
        }, input), {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.students = []
              this.$nextTick(() => {
                this.$emit('hidePopoverAndRefresh')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    }
  }
}
</script>

<style lang="scss">
  .sms-biz-student-message-send {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      padding: 12px 15px;
      & > .label {
        color: #909399;
        font-size: 12px;
      }
    }
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
    & > .footer {
      flex: none;
      padding: 15px;
      display: flex;
      align-items: stretch;
      & > .input {
        flex: auto;
        .el-select {
          width: 100%;
        }
      }
      & > .extra {
        margin-left: 10px;
        flex: none;
        .el-button {
          min-width: 90px;
          height: 100%;
        }
      }
    }
  }
  .el-select-dropdown {
    &.sms-biz-student-message-send-dropdown {
      .el-select-dropdown__wrap {
        .el-select-dropdown__list {
          .el-select-dropdown__item {
            .custom-option {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
          }
          .el-pagination {
            margin: 6px 0 -6px;
            padding: 6px 4px;
            border-top: 1px solid rgba(0,0,0,.03);
            .el-pagination__rightwrapper {
              .el-pagination__total {
                font-size: 12px;
              }
            }
            .btn-prev,
            .btn-next {
              padding: 0 6px;
              background-color: transparent;
            }
            .el-pager {
              & > li {
                font-weight: normal;
                background-color: transparent;
              }
            }
          }
        }
      }
    }
  }
</style>
